/**
 * DOKIDUO ANIME THEME - ANIMATIONS & INTERACTIONS
 * Marquee animations, floating elements, and smooth interactions
 */

(function() {
  'use strict';

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initMarquee();
    initFloatingElements();
    initSmoothScroll();
    initProductCardEnhancements();
  }

  /**
   * Initialize marquee animation for announcement bar
   */
  function initMarquee() {
    const marqueeContainers = document.querySelectorAll('[data-marquee]');
    
    marqueeContainers.forEach(container => {
      const content = container.innerHTML;
      // Duplicate content for seamless loop
      container.innerHTML = content + content;
      container.classList.add('animate-marquee');
    });
  }

  /**
   * Create floating decorative elements (stars, hearts)
   */
  function initFloatingElements() {
    const heroSection = document.querySelector('.hero, [data-section-type="hero"]');
    if (!heroSection) return;

    // Only add on desktop
    if (window.innerWidth < 768) return;

    const elements = [
      { type: 'star', color: 'neon-pink', top: '20%', left: '10%', duration: 4 },
      { type: 'heart', color: 'neon-purple', top: '30%', right: '15%', duration: 5 },
      { type: 'star', color: 'neon-purple', bottom: '25%', left: '8%', duration: 4.5 },
      { type: 'heart', color: 'neon-pink', top: '60%', right: '10%', duration: 3.5 }
    ];

    elements.forEach(el => {
      const floater = createFloatingElement(el);
      heroSection.appendChild(floater);
    });
  }

  /**
   * Create a floating decorative element
   */
  function createFloatingElement({ type, color, top, bottom, left, right, duration }) {
    const div = document.createElement('div');
    div.className = `floating-element floating-element--${type} float-gentle`;
    div.style.position = 'absolute';
    div.style.pointerEvents = 'none';
    div.style.opacity = '0.3';
    div.style.zIndex = '1';
    div.style.animationDuration = `${duration}s`;
    
    if (top) div.style.top = top;
    if (bottom) div.style.bottom = bottom;
    if (left) div.style.left = left;
    if (right) div.style.right = right;

    const svg = createSVGIcon(type, color);
    div.appendChild(svg);

    return div;
  }

  /**
   * Create SVG icons for floating elements
   */
  function createSVGIcon(type, color) {
    const colorMap = {
      'neon-pink': '#FF1493',
      'neon-purple': '#9945FF',
      'neon-blue': '#6B8EFF'
    };

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '24');
    svg.setAttribute('height', '24');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', colorMap[color] || '#FF1493');

    if (type === 'star') {
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M12 2L14.09 8.26L20.18 9.27L15.54 13.14L16.82 19.07L12 16.27L7.18 19.07L8.46 13.14L3.82 9.27L9.91 8.26L12 2Z');
      svg.appendChild(path);
    } else if (type === 'heart') {
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 12.27 18.6 15.36 13.45 20.03L12 21.35Z');
      svg.appendChild(path);
    }

    return svg;
  }

  /**
   * Smooth scroll for anchor links
   */
  function initSmoothScroll() {
    const links = document.querySelectorAll('a[href^="#"]');
    
    links.forEach(link => {
      link.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href === '#' || href === '') return;
        
        const target = document.querySelector(href);
        if (!target) return;

        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });
    });
  }

  /**
   * Enhanced product card interactions
   */
  function initProductCardEnhancements() {
    const productCards = document.querySelectorAll('.product-card, .collection-card');
    
    productCards.forEach(card => {
      // Add data attribute for tracking
      card.setAttribute('data-enhanced', 'true');

      // Add ripple effect on click
      card.addEventListener('click', function(e) {
        if (e.target.tagName === 'A' || e.target.closest('a')) return;
        
        const ripple = document.createElement('span');
        ripple.className = 'card-ripple';
        ripple.style.position = 'absolute';
        ripple.style.borderRadius = '50%';
        ripple.style.background = 'rgba(153, 69, 255, 0.3)';
        ripple.style.pointerEvents = 'none';
        
        const rect = this.getBoundingClientRect();
        const size = Math.max(rect.width, rect.height);
        const x = e.clientX - rect.left - size / 2;
        const y = e.clientY - rect.top - size / 2;
        
        ripple.style.width = ripple.style.height = size + 'px';
        ripple.style.left = x + 'px';
        ripple.style.top = y + 'px';
        
        this.style.position = 'relative';
        this.style.overflow = 'hidden';
        this.appendChild(ripple);
        
        setTimeout(() => ripple.remove(), 600);
      });
    });
  }

  /**
   * Add glow effect to primary buttons
   */
  function enhanceButtons() {
    const primaryButtons = document.querySelectorAll('.button--primary, button[type="submit"]');
    
    primaryButtons.forEach(button => {
      if (!button.classList.contains('glow-pink')) {
        button.classList.add('glow-pink');
      }
    });
  }

  // Run button enhancement after a short delay for dynamically loaded content
  setTimeout(enhanceButtons, 500);

})();
